import React from 'react';
import PropTypes from 'prop-types';

import './Steps.scss';

const Steps = ({ step }) => (
  <div className="steps">
    <div className="steps__inner">
      <div className={`steps__step steps__step--1 ${step >= '1' ? '--selected' : ''}`}>
        <div className="steps__step__number">{step > 1 ? <i className="steps__step__number__tick" /> : '1'}</div>
        <div className="steps__step__description">Confirm your charity</div>
      </div>
      <div className={`steps__step steps__step--2 ${step >= '2' ? '--selected' : ''}`}>
        <div className="steps__step__number">{step > 2 ? <i className="steps__step__number__tick" /> : '2'}</div>
        <div className="steps__step__description">Invite your friends</div>
      </div>
      <div className={`steps__step steps__step--3 ${step >= '3' ? '--selected' : ''}`}>
        <div className="steps__step__number">{step > 3 ? <i className="steps__step__number__tick" /> : '3'}</div>
        <div className="steps__step__description">Match your miles</div>
      </div>
    </div>
  </div>
);

Steps.propTypes = {
  step: PropTypes.string,
};

Steps.defaultProps = {
  step: '1',
};

export default Steps;



// WEBPACK FOOTER //
// ./components/Steps/Steps.js